export const ADD_INTERESTING_EVENT = 'ADD_INTERESTING_EVENT'
export const REQUEST_INTERESTING_EVENTS = 'REQUEST_INTERESTING_EVENTS'
export const RECEIVE_INTERESTING_EVENTS = 'RECEIVE_INTERESTING_EVENTS'
export const REMOVE_INTERESTING_EVENT = 'REMOVE_INTERESTING_EVENT'

export const addInterestingStream = stream => ({
  type: ADD_INTERESTING_EVENT,
  stream
})

const requestMyEventsStreams = () => ({
  type: REQUEST_INTERESTING_EVENTS
})

const receiveMyEventsStreams = (streams) => ({
  type: RECEIVE_INTERESTING_EVENTS,
  streams
})

const removeInterestingEvent = (id) => ({
  type: REMOVE_INTERESTING_EVENT,
  payload: {
    id
  }
})

export const fetchRemoveInterestingEvent = (personId, streamId) => dispatch => {
  return fetch(process.env.REACT_APP_BASE_URL + '/interestedevents/remove_interested_event',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ personId, streamId })
    }).then(() => dispatch(removeInterestingEvent(streamId)))
}

export const fetchInterestingEventsSterams = personId => dispatch => {
  dispatch(requestMyEventsStreams())

  return fetch(process.env.REACT_APP_BASE_URL + '/interestedevents/get_interested_events',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ personId })
    })
    .then(
      response => response.json(),
      error => console.log('An error occurred', error)
    )
    .then(json => dispatch(receiveMyEventsStreams(json)))
}

export const fetchAddInterestingEvent = (personId, stream) => dispatch => {
  return fetch(process.env.REACT_APP_BASE_URL + '/interestedevents/add_interested_event',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ personId, streamId: stream.id })
    })
    .then(
      response => dispatch(addInterestingStream(stream)),
      error => console.log('An error occurred', error)
    )
}
